<template>
  <v-row>
    <p
      class="Hero-Text"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Laporan Keuangan {{ $route.params.id }}
    </p>

    <img
      src="../../assets/SyaratKetentuan/Hero.png"
      srcset="
        ../../assets/SyaratKetentuan/Hero@2x.png 2x,
        ../../assets/SyaratKetentuan/Hero@3x.png 3x
      "
      class="Hero"
    />
    <v-col class="pdfContainer mx-auto">
      <v-img
        v-for="i in 10"
        :key="i"
        class="LaporanKeuangan mx-auto"
        :src="
          require('../../assets/InformasiLainnya/' +
            $route.params.id +
            '/report-' +
            i +
            '.jpg')
        "
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
    };
  },
  mounted() {
    this.onResize();
    console.log(this.getImage(1));
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 3}px`;
      this.marginTop = `${window.innerWidth / 14}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 40}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin-top: -80px;
  object-fit: contain;
}
.Hero-Text {
  width: 763px;
  height: 56px;
  margin: 101px 418px 0 419px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.pdfContainer {
  overflow-y: scroll;
  max-height: 100vh;
  max-width: 85vh;
  margin-top: 50px;
  background-color: gray;
}
.LaporanKeuangan {
  max-width: 80vh;
  margin-bottom: 20px;
}
</style>
